import { stringToPrice } from "../utils/currency";

export class Payment {
  constructor(
    paymentCode,
    amount,
    currency,
    paymentProvider,
    paymentMethod,
    paymentDate
  ) {
    this.paymentCode = paymentCode;
    this.amount = amount;
    this.currency = currency;
    this.paymentProvider = paymentProvider;
    this.paymentMethod = paymentMethod;
    this.paymentDate = paymentDate;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Payment(
        input.code,
        stringToPrice(input.amount),
        input.cur,
        input.payment_provider,
        input.payment_method,
        input.updated_at
      )
    }

    return new Payment();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Payment.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Payment.fromApiObject(input)];
    }

    return [];
  }
}